import React, { memo, useRef, useCallback, useEffect } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const HtmlTextEditor = (props) => {
  const editor = useRef(null);
  const editorRef = useRef();

  const getSunEditorInstance = (sunEditor) => {
    editor.current = sunEditor;
  };

  // ✅ Use useCallback to prevent unnecessary re-renders
  const handleChange = useCallback(
    (value) => {
      if (props?.onChange) {
        props.onChange(value);
      }
    },
    [props?.onChange]
  );
 useEffect(() => {
    setTimeout(() => {
      if (editorRef.current) {
        try {
          editorRef.current.editor.core._resizing.resizeEditor();
        } catch (e) {
          console.warn("Editor resize workaround failed", e);
        }
      }
    }, 500); // allow DOM to stabilize
  }, []);
  return (
    <SunEditor
      ref={editorRef}
      setOptions={{
        buttonList: [
          ["font", "fontSize", "formatBlock"],
          [
            "bold",
            "underline",
            "italic",
            "strike",
            "subscript",
            "superscript",
          ],
          ["fontColor", "hiliteColor"],
          ["align", "horizontalRule", "list", "table"],
          ["outdent", "indent"],
          ["undo", "redo"],
          ["removeFormat"],
          ["link", "image", "video"],
          ["showBlocks", "codeView", "save"],
        ],
        defaultTag: "div",
        showPathLabel: false,
      }}
      setContents={props?.value} // ✅ Ensure correct value update
      onChange={handleChange} // ✅ Optimized change handler
      getSunEditorInstance={getSunEditorInstance}
      height={props?.height ?? "60vh"}
      width={props?.width ?? "100%"}
      disable={props?.isDisable}
    />
  );
};

export default memo(HtmlTextEditor);
